import { Box, Grid, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import useLayout from 'stores/useLayout';
import { colors } from '../../styles/theme/colors';
import fonts from '../../styles/theme/fonts';
import { LinkedLogotype } from '../Logotype/LinkedLogotype';

type FooterProps = {
    isStartPage?: boolean;
};

export default function Footer({ isStartPage }: FooterProps) {
    const content = useLayout((state) => state.footer);
    if (!content) {
        return null;
    }

    return (
        <>
            <Box sx={{ borderTop: `1px solid ${colors.gray1}` }} />
            <Grid
                container
                maxWidth={isStartPage ? 1024 : 1200}
                m="auto"
                sx={{
                    width: '100%',
                    height: '100%',
                    padding: { xs: '16px', md: '24px' },
                    fontFamily: fonts.notoSans,
                }}
            >
                <Grid item xs={12}>
                    <div dangerouslySetInnerHTML={{ __html: content }} className="footer" />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <LinkedLogotype linkProps={{
                        sx: {
                            padding: 1,
                            display: 'inline-block',
                            '& img': {
                                width: 134,
                                height: 19,
                            },
                        },
                    }}
                    />
                    <Typography>
                        ©
                        {' '}
                        {DateTime.now().year }
                        {' '}
                        Lesley Cosmetics Mary Kay
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
}
